"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BootAction = void 0;
var tslib_1 = require("tslib");
var analytics_1 = require("@dp-instant/analytics");
var interfaces_1 = require("@dp-instant/interfaces");
var utils_1 = require("@dp-instant/utils");
var i18n_1 = require("@dp-instant/i18n");
var core_1 = require("@dp-instant/core");
var social_1 = require("@dp-instant/social");
var Sentry = tslib_1.__importStar(require("@sentry/browser"));
var inversify_1 = require("inversify");
var BootAction = (function (_super) {
    tslib_1.__extends(BootAction, _super);
    function BootAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BootAction.prototype.execute = function () {
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var APP_META, tracker, gameConfig, i18n, loginPromise;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (process.env.NODE_ENV === "development") {
                            window.social = this.social;
                            window.locale = i18n_1.Localize;
                            console.time("BootAction.run");
                            console.groupCollapsed("BootAction");
                        }
                        APP_META = __APP__META__;
                        if (APP_META) {
                            core_1.di.rebind(interfaces_1.TypesCore.gameConfig).toConstantValue(APP_META);
                        }
                        tracker = (0, core_1.lazyGet)(interfaces_1.TypesAnalytics.tracker);
                        tracker === null || tracker === void 0 ? void 0 : tracker.addProvider(new analytics_1.GTAGAnalyticsProvider());
                        gameConfig = core_1.di.get(interfaces_1.TypesCore.gameConfig);
                        (0, core_1.lazyRun)("template.action");
                        i18n = gameConfig.i18n;
                        if (i18n) {
                            i18n_1.Localize.addTemplates(i18n);
                        }
                        return [4, Promise.all([
                                this.page.isBusReadyAsync().then(function () {
                                    loginPromise = (0, core_1.lazyRun)(interfaces_1.TypesApp.loginAction);
                                }),
                                (0, core_1.lazyRun)(interfaces_1.TypesFlow.assetsPreload)
                            ])];
                    case 1:
                        _d.sent();
                        this.page.assetsProgress = 1;
                        utils_1.log.trace("all done");
                        return [4, this.social.startGameAsync()];
                    case 2:
                        _d.sent();
                        (0, core_1.lazyRun)(interfaces_1.TypesAudio.initAction);
                        return [4, (0, core_1.lazyRun)(interfaces_1.TypesFlow.UI.setupAction)];
                    case 3:
                        _d.sent();
                        Promise.all([interfaces_1.TypesFlow.assetsProcess, interfaces_1.TypesAds.initAction].map(core_1.lazyRun)).then();
                        return [4, this.social.init((_a = this.page.bus) === null || _a === void 0 ? void 0 : _a.params)];
                    case 4:
                        _d.sent();
                        (function () {
                            var _a = _this.social.me, id = _a.id, name = _a.name, photo = _a.photo;
                            Sentry.setUser({ id: id, name: name, photo: photo, locale: i18n_1.Localize.defaultLocale });
                        })();
                        (_b = (0, core_1.lazyGet)(interfaces_1.TypesSocial.refRewardsModel)) === null || _b === void 0 ? void 0 : _b.init();
                        if (process.env.NODE_ENV === "development") {
                            console.group("Localizations");
                            i18n_1.Localize.templates.forEach(function (v, k) { return console.log("[".concat(k, "]"), i18n_1.Localize.get(k)); });
                            console.groupEnd();
                        }
                        return [4, loginPromise];
                    case 5:
                        _d.sent();
                        social_1.AdManagerBase.config.throttling.interstitial.systemStart = Date.now();
                        if (process.env.NODE_ENV === "development") {
                            console.groupEnd();
                            console.timeEnd("BootAction.run");
                            console.log.apply(null, ["\n %c Game started \n ", "padding:10px"]);
                        }
                        return [4, (0, core_1.lazyRun)(interfaces_1.TypesFlow.mainAction)];
                    case 6:
                        _d.sent();
                        return [4, ((_c = (0, core_1.lazyGet)(interfaces_1.TypesAudio.model)) === null || _c === void 0 ? void 0 : _c.activateBackgroundMusic())];
                    case 7:
                        _d.sent();
                        return [2];
                }
            });
        });
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesApp.pageModel),
        tslib_1.__metadata("design:type", social_1.PageModel)
    ], BootAction.prototype, "page", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], BootAction.prototype, "social", void 0);
    BootAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], BootAction);
    return BootAction;
}(core_1.Action));
exports.BootAction = BootAction;
//# sourceMappingURL=BootAction.js.map